


export default
{
    code:'BUS_US_BLACKROCK',
    currencies: ['USD','NZD','EUR'],
    content:{
        logo: {
            link: 'https://res.cloudinary.com/carbonclick/image/upload/v1753472235/cms-qualeu/MERCHANT/BUS_US_BLACKROCK/logo-light.svg'
        },
        menu: {
            menuIconColor: true,
            url: 'https://res.cloudinary.com/carbonclick/image/upload/v1753472235/cms-qualeu/MERCHANT/BUS_US_BLACKROCK/logo-dark.svg',
            business: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
            individual: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
        },
        myMovementPanel: {
            hideMovementInvitation: true,
            hideMovementCreation: true,
        },
        signIn: {
            individual: {
                hideSocialMedia: true,
            }
        },
    },
}
